/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetMemoryStoreRequest = {
  memoryStoreId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const GetMemoryStoreRequest$inboundSchema: z.ZodType<
  GetMemoryStoreRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  memory_store_id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "memory_store_id": "memoryStoreId",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type GetMemoryStoreRequest$Outbound = {
  memory_store_id: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const GetMemoryStoreRequest$outboundSchema: z.ZodType<
  GetMemoryStoreRequest$Outbound,
  z.ZodTypeDef,
  GetMemoryStoreRequest
> = z.object({
  memoryStoreId: z.string(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    memoryStoreId: "memory_store_id",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function getMemoryStoreRequestToJSON(
  getMemoryStoreRequest: GetMemoryStoreRequest,
): string {
  return JSON.stringify(
    GetMemoryStoreRequest$outboundSchema.parse(getMemoryStoreRequest),
  );
}
export function getMemoryStoreRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetMemoryStoreRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetMemoryStoreRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetMemoryStoreRequest' from JSON`,
  );
}
